import React from 'react';
import { SecureProfilePhoto } from '@/components/profile/SecureProfilePhoto';
import { getRoleBadgeColor } from '@/utils/roleDisplay';

interface UserMenuHeaderProps {
  profilePhotoPath: string | null;
  initials: string;
  displayName: string;
  role: string;
}

export const UserMenuHeader: React.FC<UserMenuHeaderProps> = ({
  profilePhotoPath,
  initials,
  displayName,
  role
}) => {
  const roleColor = getRoleBadgeColor(role);
  
  return (
    <div className="p-4 border-b border-gray-800">
      <div className="flex items-center gap-3">
        <SecureProfilePhoto
          filePath={profilePhotoPath}
          fallbackInitials={initials}
          size="sm"
          className="w-10 h-10 border-2 border-sports-green rounded-full"
        />
        <div>
          <p className="text-white font-medium">{displayName}</p>
          <p className={`text-sm ${roleColor}`}>{role}</p>
        </div>
      </div>
    </div>
  );
};
